import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetDistinctEcrCodesResData } from "./GetDistinctEcrCodesResData";

const ENDPOINT = "/fitness_statistics/distinct_ecr"

export class GetDistinctEcrCodesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetDistinctEcrCodesResData> {
        var res = await this.executeCommand(null, null);
        return new GetDistinctEcrCodesResData(res);
    }


}